import { CircularProgress, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ORANGE_COLOR } from '../../../constants/ColorsConst';
import { AlertWidget, ModalComponent } from '../../../widgets';
import { allEstudiantesAsistenciasAction } from '../../control_estudios/asistencias/AsistenciasAction';
import DetallesPlanEvaluacionComponent from '../../control_estudios/plan_evaluacion/plan_evaluacion/panel/components/DetallesPlanEvaluacion';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEstudiantesNotasBlopedAction,
  allEstudiantesPlanNotasBlopedAction,
  setActivoNotasBlopedAction,
} from './NotasBlopedAction';
import { IS_DISABLED_DATA } from './NotasBlopedReducer';
import CardEstudianteNotasBlopedComponent from './components/CardEstudianteNotasBloped';
import FiltrosNotasBlopedComponent from './components/FiltrosNotasBloped';
import ListadoEstudiantesNotasBloped from './components/ListadoEstudiantesNotasBloped';

const NotasBlopedView = () => {
  const dispatch = Redux.useDispatch();

  const notasBlopedStore = Redux.useSelector((state) => state.notasBloped);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [isStudent, setIsStudent] = React.useState(false);
  const [openModalPlaneva, setOpenModalPlaneva] = React.useState(false);

  React.useEffect(() => {
    setIsStudent(estudiantesStore.activo !== null);
  }, [estudiantesStore.activo]);

  return (
    <Grid container spacing={1}>
      <AlertWidget alert={notasBlopedStore.alertView} />
      <Grid item md={10}>
        <BotonComponent
          click={async () => {
            await setActivoNotasBlopedAction(dispatch, null);
          }}
          green
          mr={2}
        />
        {notasBlopedStore.all.length > 0 && (
          <BotonComponent
            click={async () => {
              await setActivoNotasBlopedAction(dispatch, null);
              await allEstudiantesNotasBlopedAction(
                dispatch,
                notasBlopedStore.params,
                true,
              );
            }}
            disabled={notasBlopedStore.loadingAll}
            white
            text={
              notasBlopedStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
            mr={2}
          />
        )}
        {notasBlopedStore.planEvaluacion ? (
          <BotonComponent
            click={async () => {
              await allEstudiantesPlanNotasBlopedAction(
                dispatch,
                notasBlopedStore.params,
              );
              const params = {
                ...notasBlopedStore.params,
              };
              delete params.bloquePedagogico;
              await allEstudiantesAsistenciasAction(dispatch, {
                ...params,
                fechaInicio: notasBlopedStore.planEvaluacion.fechaBloque.desde,
                fechaFinal: notasBlopedStore.planEvaluacion.fechaBloque.hasta,
              });
              dispatch({ type: IS_DISABLED_DATA, payload: true });
            }}
            disabled={notasBlopedStore.loadingAll}
            blue
            text="Extraer notas desde el plan de evaluacion"
            mr={2}
          />
        ) : null}
        {notasBlopedStore.allEstudiantesPlan.length > 0 ? (
          <BotonComponent
            click={async () => {
              dispatch({
                type: IS_DISABLED_DATA,
                payload: !notasBlopedStore.isDisabledData,
              });
            }}
            green={notasBlopedStore.isDisabledData}
            red={!notasBlopedStore.isDisabledData}
            text={
              !notasBlopedStore.isDisabledData
                ? 'Bloquear campos'
                : 'Habilitar campos'
            }
            mr={2}
          />
        ) : null}
      </Grid>
      <Grid
        item
        md={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {notasBlopedStore.planEvaluacion ? (
          notasBlopedStore.loadingPlanEva ? (
            <CircularProgress size="1.5rem" />
          ) : (
            <BotonComponent
              text="Plan de evaluación"
              click={() => {
                setOpenModalPlaneva(true);
              }}
              color={ORANGE_COLOR}
            />
          )
        ) : null}
      </Grid>
      <Grid item md={12}>
        <FiltrosNotasBlopedComponent />
      </Grid>
      {isStudent && (
        <Grid item md={4}>
          {estudiantesStore.activo && <CardEstudianteNotasBlopedComponent />}
        </Grid>
      )}
      <Grid item md={isStudent ? 8 : 12}>
        <ListadoEstudiantesNotasBloped />
      </Grid>
      <ModalComponent
        id="modalFormPlanEvaluacion"
        title={`Plan de evaluación`}
        open={openModalPlaneva}
        maxWidth="lg"
        onClose={() => setOpenModalPlaneva(!openModalPlaneva)}
      >
        <DetallesPlanEvaluacionComponent
          planEvaluacion={notasBlopedStore.planEvaluacion}
        />
      </ModalComponent>
    </Grid>
  );
};

export default NotasBlopedView;
